export function formatAmount(value) {
  const num = Number(value || 0);
  return num.toLocaleString("en-PK", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function formatCurrency(value) {
  return `PKR ${formatAmount(value)}`;
}

export function formatPercent(value) {
  const num = Number(value || 0);
  return `${num.toFixed(2)}%`;
}

export function normalizeRole(role) {
  const value = String(role || "").toLowerCase();
  if (value.includes("super")) return "superadmin";
  if (value.includes("admin")) return "admin";
  if (value.includes("manager")) return "manager";
  return "sales";
}

export function isSuperAdmin(userOrRole) {
  const role = typeof userOrRole === "object" ? userOrRole?.role : userOrRole;
  return normalizeRole(role) === "superadmin";
}

export function isAdmin(userOrRole) {
  const role = typeof userOrRole === "object" ? userOrRole?.role : userOrRole;
  const r = normalizeRole(role);
  return r === "admin" || r === "superadmin";
}

export function isManager(userOrRole) {
  const role = typeof userOrRole === "object" ? userOrRole?.role : userOrRole;
  return normalizeRole(role) === "manager";
}

export function canViewProfit(userOrRole) {
  return isAdmin(userOrRole) || isManager(userOrRole);
}

export function getRoleLabel(role) {
  const norm = normalizeRole(role);
  if (norm === "superadmin") return "Super Admin";
  if (norm === "admin") return "Administrator";
  if (norm === "manager") return "Manager";
  return "Sales Representative";
}
